import { render, staticRenderFns } from "./jkhcDialog.vue?vue&type=template&id=1e58b51d&scoped=true&"
import script from "./jkhcDialog.vue?vue&type=script&lang=js&"
export * from "./jkhcDialog.vue?vue&type=script&lang=js&"
import style0 from "./jkhcDialog.vue?vue&type=style&index=0&id=1e58b51d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e58b51d",
  null
  
)

export default component.exports